/** @format */

import { useState, useCallback } from 'react';
import { deletePolicy } from '../services/deletePolicy';

interface UseDeletePolicyReturn {
  deleteLoading: boolean;
  deleteError: string | null;
  deletePolicyById: (policyId: string) => Promise<boolean>;
  clearDeleteError: () => void;
}

/**
 * Custom hook for deleting policies
 */
export const useDeletePolicy = (): UseDeletePolicyReturn => {
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [deleteError, setDeleteError] = useState<string | null>(null);

  const deletePolicyById = useCallback(async (policyId: string): Promise<boolean> => {
    setDeleteLoading(true);
    setDeleteError(null);

    try {
      await deletePolicy(policyId);
      return true;
    } catch (error: any) {
      setDeleteError(error.message || 'Failed to delete policy');
      return false;
    } finally {
      setDeleteLoading(false);
    }
  }, []);

  const clearDeleteError = useCallback(() => {
    setDeleteError(null);
  }, []);

  return {
    deleteLoading,
    deleteError,
    deletePolicyById,
    clearDeleteError,
  };
};
